export interface Withdraw {
  amount: number;
  account_number: string;
  user_id: string;
  status: string;
  created_at: Date;
  updated_at: Date;
  id: string;
}

export const INITIAL_STATE = {
  amount: 0,
  account_number: '',
  user_id: '',
  status: '',
  created_at: new Date(),
  updated_at: new Date(),
  id: '',
};
